import { useMemo } from 'react';

import { LoginType, Role } from '@shared/enums';
import { useAuth } from './AuthHook';

export const useAuthSelectors = () => {
    const { user } = useAuth();

    return useMemo(() => {
        const roles = user?.Roles ?? [];
        const loginTypes = user?.LoginTypes ?? [];
        const roleSet = new Set(roles);
        const loginTypeSet = new Set(loginTypes);

        const hasRole = (role: Role) => roleSet.has(role);
        const hasLoginType = (type: LoginType) => loginTypeSet.has(type);

        return {
            roles,
            loginTypes,
            hasRole,
            hasLoginType,
            isAdmin: hasRole(Role.Admin),
        };
    }, [user?.Roles, user?.LoginTypes]);
};
